export const MAX_BOTTLES = 24;
export const FUNCTIONAL_SINGLE = 1200;
export const TRADITIONAL_SINGLE = 1000;

export const functionalPack = (n) => {
  const sixes = Math.floor(n / 6), rem = n % 6;
  const threes = Math.floor(rem / 3), singles = rem % 3;
  return sixes * 5400 + threes * 2800 + singles * FUNCTIONAL_SINGLE;
};

export const priceFor = (nf, nt) => (nf > 0 ? functionalPack(nf) : 0) + nt * TRADITIONAL_SINGLE;

export const stackLabel = (n) => (n === 1 ? "Single Bottle" : n === 3 ? "3-Pack" : n === 6 ? "6-Pack" : `${n} Bottles`);

export const stackKey = (n) => (n === 1 ? "single" : n === 3 ? "three_pack" : n === 6 ? "six_pack" : `stack_${n}`);

export const functionalBreakdown = (n) => {
  const sixes = Math.floor(n / 6), rem = n % 6;
  const threes = Math.floor(rem / 3), singles = rem % 3;
  const parts = [];
  if (sixes) parts.push(`${sixes}× 6-pack`);
  if (threes) parts.push(`${threes}× 3-pack`);
  if (singles) parts.push(`${singles}× single`);
  return parts.join(" + ");
};
